import type { Caption } from '../lib/captions'

interface CaptionsProps {
  caption: Caption
}

export function Captions({ caption }: CaptionsProps): JSX.Element | null {
  if (!caption.text) return null

  // Rendered as text, never as markup. Transcripts and item names are
  // attacker-influenceable and there is an open stored-XSS finding against the
  // agent's own pages for exactly this — JSX interpolation is what keeps it
  // from being inherited here.
  return (
    <p
      className={`mt-6 max-w-md text-[15px] leading-relaxed ${
        caption.who === 'you' ? 'text-white/45' : 'text-white/85'
      }`}
    >
      {caption.who === 'you' ? `“${caption.text}”` : caption.text}
    </p>
  )
}
